import { api } from './api-client';

// ============================================================================
// Types
// ============================================================================

export interface CurriculumOutcome {
  id: string;
  grade: string;
  subject: string;
  outcomeText: string;
}

export interface CurriculumOutcomesResponse {
  items: CurriculumOutcome[];
  total: number;
}

// ============================================================================
// Service
// ============================================================================

class CurriculumService {
  /**
   * Get all curriculum outcomes.
   * Public endpoint - no auth required.
   */
  async getOutcomes(signal?: AbortSignal): Promise<CurriculumOutcome[]> {
    const response = await api.get<CurriculumOutcomesResponse>(
      '/curriculum/outcomes',
      { signal }
    );
    return response.items;
  }
}

export const curriculumService = new CurriculumService();
